import { render, staticRenderFns } from "./Exnews-add.vue?vue&type=template&id=19497ba0&scoped=true&"
import script from "./Exnews-add.vue?vue&type=script&lang=js&"
export * from "./Exnews-add.vue?vue&type=script&lang=js&"
import style0 from "./Exnews-add.vue?vue&type=style&index=0&id=19497ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19497ba0",
  null
  
)

export default component.exports